<div
  class="preview"
  [ngClass]="{
    'is-closed': isHiding
  }"
  *ngIf="isOpen"
>
  <div
    class="preview-header"
  >
    <span
      class="preview-header__tittle"
    >
      {{ damElement?.header }}
    </span>
    <span
      class="preview-header__id"
    >
      ID {{ damElement?.id }}
    </span>
    <span
      class="preview-header__files-count"
    >

          <nb-icon icon="attach-outline"/>

      {{ damElement?.countVersion }}
      {{ createLabel(damElement?.countVersion, 'вложение|вложения|вложений') }}
    </span>

    <nb-icon icon="close" (click)="onCloseEvent()"/>
  </div>

  <div
    class="preview-section preview-images"
  >
    <div
      class="preview-images-carousel"
    >
      <button
        class="btn-prev"
        nbButton
        [disabled]="carouselIndex === 0"
        type="button"
        (click)="carousel.prev()"
      >
        <nb-icon icon="chevron-left-outline"/>
      </button>

      <tui-carousel
        #carousel
        [(index)]="carouselIndex"
        (indexChange)="cons()"
      >
        <ng-container *ngFor="let image of filterVersions(damItemVersions)">
          <div
            *tuiItem
            class="item"
          >
            <app-secured-image *ngIf="showThumbnail(image.mimeType)" [src]="'/dam/get-image-dynamic-version/' + image?.id"></app-secured-image>
            <img *ngIf="!showThumbnail(image.mimeType)" style="max-width:100px" src="/assets/images/dam/vivid/{{getExtension(image)}}.svg" alt="">
            <!--            <img-->
            <!--              class="carousel-img"-->
            <!--              [src]="image?.href" alt=""-->
            <!--            >-->
          </div>
        </ng-container>
      </tui-carousel>

      <button
        class="btn-next"
        nbButton
        [disabled]="(damItemVersions?.length - 1) === carouselIndex"
        type="button"
        (click)="carousel.next()"
      >
        <nb-icon icon="chevron-right-outline"/>
      </button>
    </div>

    <div
      class="selected-img-tittle"
      *ngIf="damItemVersions[carouselIndex]"
    >
      {{ damItemVersions[carouselIndex]?.header || 'no tittle' }}
    </div>

    <div
      class="preview-images-list"
    >
      <div
        *ngFor="let image of filterVersions(damItemVersions); index as i"
        class="preview-images-list-item"
        (click)="setCarouselIndex(i)"
      >
        <app-secured-image *ngIf="showThumbnail(image.mimeType)" [src]="'/dam/get-image-dynamic-version/' + image?.id"></app-secured-image>
        <img *ngIf="!showThumbnail(image.mimeType)" style="max-height:62px" src="/assets/images/dam/vivid/{{getExtension(image)}}.svg" alt="">
        <!--        <img-->
        <!--          class="preview-images-list-item__img"-->
        <!--          [ngClass]="{'active': i === carouselIndex}"-->
        <!--          src="/dam/get-image-dynamic-version/{{image.id}}" alt=""-->
        <!--        >-->
      </div>
    </div>

    <tui-pagination
      size="s"
      class="pagination"
      [length]="filterVersions(damItemVersions).length"
      [(index)]="carouselIndex"
    ></tui-pagination>

    <div
      class="files-actions"
    >
      <app-dropdown
        [name]="'see-more'"
        index="1"
        style="width: 198px;"
      >
        <ng-container ngProjectAs="placeholder">
          <button
            nbButton
            class="files-actions__download"
          >
            Скачать
            <nb-icon icon="download-outline"/>
          </button>
        </ng-container>
        <ng-container ngProjectAs="dropdown">
          <div
            class="see-more"
          >
            <span
              class="item"
              (click)="downloadDamItem()"
            >
              Скачать все
              <nb-icon icon="more-vertical-outline"/>
            </span>
            <!--            <span-->
            <!--              class="item"-->
            <!--            >-->
            <!--              Скачать выбранное-->
            <!--              <nb-icon icon="more-vertical-outline"/>-->
            <!--            </span>-->
            <span
              class="item"
              (click)="downloadDamItemVersion(damElement.id, damElement.header)"
            >
              Скачать текущий
              <nb-icon icon="more-vertical-outline"/>
            </span>
          </div>
        </ng-container>
      </app-dropdown>

      <nb-checkbox
        (checkedChange)="onAllFileExtensionsToggle($event)"
        [checked]="isAllExtensionsSelected"
      >
        Выбрать все
      </nb-checkbox>
    </div>

    <hr class="divider-horizontal">

    <div
      class="files"
    >
      <span
        class="files__count"
      >
        Выбрано: {{ filteredVersions }}
      </span>

      <div
        class="files-list"
      >
        <ng-container *ngFor="let file of fileExtensions; index as i">
          <nb-checkbox
            (checkedChange)="onFileExtensionToggle(i)"
            [checked]="file?.selected"
          >
            {{ file?.typeOfFile }}
            ({{ file?.count }})
          </nb-checkbox>

        </ng-container>
      </div>
    </div>
  </div>

  <div class="preview-section ">
    <div
      class="share-buttons"
    >
      <app-dropdown
        [name]="'see-more'"
        index="1"
        style="width: auto;"
      >
        <ng-container ngProjectAs="placeholder">
          <button
            nbButton
            size="small"
          >
            Поделиться
            <nb-icon icon="share-outline"/>
          </button>
        </ng-container>
        <ng-container ngProjectAs="dropdown">
          <div
            class="see-more"
          >
            <span
              class="item"
            >
              Скачать все
              <nb-icon icon="more-vertical-outline"/>
            </span>
            <span
              class="item"
            >
              Скачать выбранное
              <nb-icon icon="more-vertical-outline"/>
            </span>
            <span
              class="item"
            >
              Скачать текущий
              <nb-icon icon="more-vertical-outline"/>
            </span>
          </div>
        </ng-container>
      </app-dropdown>

      <app-dropdown
        [name]="'see-more'"
        index="1"
        style="width: auto;"
      >
        <ng-container ngProjectAs="placeholder">
          <button
            nbButton
            size="small"
          >
            Доступы
            <nb-icon icon="person-add-outline"/>
          </button>
        </ng-container>
        <ng-container ngProjectAs="dropdown">
          <div
            class="see-more"
          >
            <span
              class="item"
            >
              Скачать все
              <nb-icon icon="more-vertical-outline"/>
            </span>
            <span
              class="item"
            >
              Скачать выбранное
              <nb-icon icon="more-vertical-outline"/>
            </span>
            <span
              class="item"
            >
              Скачать текущий
              <nb-icon icon="more-vertical-outline"/>
            </span>
          </div>
        </ng-container>
      </app-dropdown>
    </div>

    <hr class="divider-horizontal">

    <div class="statuses">
      <nb-toggle [checked]="damElement.enabled" (checkedChange)="changeEnabled(damElement.id, $event)">
        Активен
      </nb-toggle>

      <nb-toggle [checked]="damElement.approved" (checkedChange)="changeApproved(damElement.id, $event)">
        Одобрен
        <small>{{ damElement.approvedAt | date: 'short' }} </small>
        <small *ngIf="damElement.approvedManagerName">{{ damElement.approvedManagerName }} </small>
      </nb-toggle>
      <nb-toggle [checked]="damElement.deleted" (checkedChange)="changeDeleted(damElement.id, $event)">
        Удален
        <small> {{ damElement.deletedAt | date:'short' }}</small>
      </nb-toggle>
    </div>

  </div>

  <div class="preview-section">
    <span *ngIf="damElement?.tagsForPreview?.length>0"
          class="tags-label"
    >
      Теги
    </span>

    <div *ngIf="damElement?.tagsForPreview?.length>0"
         class="tags"
    >
      <div
        *ngFor="let tag of damElement?.tagsForPreview"
        class="tags-item"
      >
        {{ tag }}
      </div>
    </div>


    <hr class="divider-horizontal" *ngIf="damElement?.tagsForPreview?.length>0">

    <div
      class="status-history"
    >
      <div class="status-history-item">
        <span> Создан {{ damElement.createdAt | date }} </span>

        <span *ngIf="damElement.managerName">
          <nb-icon icon="person-outline"/>
          {{ damElement.managerName }}
        </span>
      </div>

      <div class="status-history-item" *ngIf="damElement.updatedAt!=null">
        <span> Изменен {{ damElement.updatedAt | date }} </span>

        <!--        <span>-->
        <!--          <img class="manager-icon" src="assets/icons/Avatar.png" alt="">-->
        <!--          Manager test text-->
        <!--        </span>-->
      </div>
    </div>
  </div>

  <a
    [routerLink]="['/cabinet/dam/item/edit', damElement.id]"
    nbButton
  >
    Подробнее
  </a>
</div>
